export const ROLES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
  MANAGER: 'ROLE_MANAGER',
} as const;

/**
 * must contain 1 number (0-9)
 * must contain 1 uppercase letters
 * must contain 1 lowercase letters
 * must contain 1 non-alpha numeric number
 * is 14 characters min and unlimited with no space
 */
export const PASSWORD_REGEX =
  /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){14,}$/gm;
